function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.30129 10.2227H6.43621V12.3521H9.30129V10.2227ZM15.0315 10.2227H12.1664V12.3521H15.0315V10.2227ZM20.7616 10.2227H17.8965V12.3521H20.7616V10.2227ZM23.6267 2.76998H22.1942V0.640625H19.3291V2.76998H7.86875V0.640625H5.00367V2.76998H3.57113C1.98101 2.76998 0.72038 3.72819 0.72038 4.89934L0.706055 19.8048C0.706055 20.976 1.98101 21.9342 3.57113 21.9342H23.6267C25.2025 21.9342 26.4918 20.976 26.4918 19.8048V4.89934C26.4918 3.72819 25.2025 2.76998 23.6267 2.76998ZM23.6267 19.8048H3.57113V8.09338H23.6267V19.8048Z",
  fill: "#A4A4A4"
});

function SvgIconStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep2);
export default __webpack_public_path__ + "static/media/icon_step2.7aea3f25c24e4077abfaa5814821dbdb.svg";
export { ForwardRef as ReactComponent };